import { render, staticRenderFns } from "./ProfileLink.vue?vue&type=template&id=006fad8e&"
import script from "./ProfileLink.vue?vue&type=script&lang=js&"
export * from "./ProfileLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports